module.exports = __webpack_public_path__ + "static/media/selected_circle.bde45425.svg";